import React, { Component } from "react";
import CustomDataTableSearch from "../../../../partials/content/CustomDataTableSearch";
import { getGlAccounts } from "../../../../services/setup/finance/financeSetupService";
import withGlobalData from "../../common/withGlobalData";
class SearchGlAccount extends Component {
  state = { reload: this.props.globalData.reload, accounts: [] };

  componentDidMount() {
    this.getGlAccounts();
  }

  componentDidUpdate() {
    const { globalData } = this.props;
    const { reload } = this.state;
    if (globalData.reload !== reload) {
      this.getGlAccounts();
      this.setState({ reload: globalData.reload });
    }
  }

  async getGlAccounts() {
    const accountTypeID = this.props.accountTypeID;
    const response = await getGlAccounts(accountTypeID);
    const { data } = response.data;
    this.setState({ open: false, accounts: data.glAccounts });
  }

  render() {
    const { accounts } = this.state;
    const { onSelectGlAccount } = this.props;
    return (
      <CustomDataTableSearch
        data={accounts}
        onRefreshData={() => {
          this.getGlAccounts();
        }}
        onSelectedData={(rowData, originalEvent) => {
          onSelectGlAccount(rowData);
        }}
        columns={[
          {
            field: "select",
            body: (rowData) => (
              <React.Fragment>
                <button
                  type="button"
                  className="btn btn-label-success btn-sm btn-pill btn-bold"
                  onClick={() => onSelectGlAccount(rowData)}
                >
                  Select <i className="fas fa-angle-double-right"></i>
                </button>
              </React.Fragment>
            ),
          },
          {
            header: "Account Type",
            field: "accountTypeName",
            body: null,
            sortable: true,
          },
          {
            header: "Account Name",
            field: "accountName",
            body: null,
            sortable: true,
          },
        ]}
      />
    );
  }
}

export default withGlobalData(SearchGlAccount);
